import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Header from './Header';
import CampaignFooter from '../components/CampaignSummary/CampaignFooter';
import { useHistory } from 'react-router-dom';
import { campaignSignUp } from '../store/actions/campaign-summary-actions';
import { checkEmailAddress } from '../utilities/helpers';

const CampaignSummaryAuth = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  let searchParams = new URLSearchParams(window.location.search);

  let campaignId = searchParams.get("campaignId");
  let shareId = searchParams.get("shareId");
  const [passwordMatch, checkPassWordMatch] = useState(true);

  const [formData, setFormData] = useState(
    window.location.pathname === '/signup'
      ? {
          firstName: '',
          surName: '',
          email: '',
          password: ''
        }
      : {
          email: '',
          password: '',
        }
  );

  const inputOnchange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleRedirect = url => {
    history.push(url);
  };

  const checkPassWord = (e) => checkPassWordMatch(formData.password === e.target.value);

  const handleClick = () =>{
    console.log(formData)
    dispatch(campaignSignUp(formData,campaignId,shareId));
  }

  return (
    <div>
      <Header />
      <div style={{ display: 'flex', position: 'relative' }}>
        <div className="CampaignSummaryAuth_left-background" />
        <div className="CampaignSummaryAuth_left-container">
          <div className="CampaignSummaryAuth_left-title">
            Channel 7 would like to share an audience summary report for the
            McDonalds Monopoly campaign.
          </div>
          <div className="CampaignSummaryAuth_left-description">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi neque
            convallis odio maecenas venenatis elementum. Ultrices sit massa
            senectus amet id. Quis proin eu urna at eget convallis feugiat amet.
            Congue sed malesuada commodo amet consequat.
          </div>
          <div className="CampaignSummaryAuth_left-introduction">
            <div className="CampaignSummaryAuth_left-introduction_logo" />
            <div className="CampaignSummaryAuth_left-introduction_title">
              Who is Context iq?
            </div>
            <div className="CampaignSummaryAuth_left-introduction_description">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi
              neque convallis odio maecenas venenatis elementum. Ultrices sit
              massa senectus amet id. Quis proin eu urna at eget convallis
              feugiat amet. Congue sed malesuada commodo amet consequat.
            </div>
          </div>
        </div>

        <div className="CampaignSummaryAuth_right-container">
          <div className="CampaignSummaryAuth_right-title">
            {window.location.pathname === '/signup'
              ? `Create Account`
              : `Sign in`}
          </div>
          <div className="CampaignSummaryAuth_right-descripstion">
            To view this report, create an account now. Already have an account,
            {window.location.pathname === '/signup' ? (
              <p
                className="CampaignSummaryAuth_right-redirect"
                onClick={() => handleRedirect('/campaign-signin')}
              >
                Sign in now
              </p>
            ) : (
              <p
                className="CampaignSummaryAuth_right-redirect"
                onClick={() => handleRedirect('/signup')}
              >
                Create an account
              </p>
            )}
          </div>

          {window.location.pathname === '/signup' && (
            <React.Fragment>
              <div>
                <h3 className="CampaignSummaryAuth_right-field-name">
                  First Name
                </h3>
                <input
                  className="CampaignSummaryAuth_right-input-style"
                  name="firstName"
                  onChange={inputOnchange}
                />
              </div>

              <div>
                <h3 className="CampaignSummaryAuth_right-field-name">
                  Surname
                </h3>
                <input
                  className="CampaignSummaryAuth_right-input-style"
                  name="surName"
                  onChange={inputOnchange}
                />
              </div>
            </React.Fragment>
          )}

          <div>
            <h3 className="CampaignSummaryAuth_right-field-name">
              Email address
            </h3>
            <input
              className="CampaignSummaryAuth_right-input-style"
              name="email"
              onChange={inputOnchange}
            />
            <br/>
            {!checkEmailAddress(formData.email) && <span className="CampaignSummaryAuth_error-message">Email format incorrect</span>}
          </div>
          <div>
            <h3 className="CampaignSummaryAuth_right-field-name">Password</h3>
            <input
              className="CampaignSummaryAuth_right-input-style"
              name="password"
              type="password"
              onChange={inputOnchange}
            />
          </div>
          {window.location.pathname === '/signup' && (
            <div>
              <h3 className="CampaignSummaryAuth_right-field-name">
                Confirm Password
              </h3>
              <input
                className="CampaignSummaryAuth_right-input-style"
                name="confirmPassWord"
                type="password"
                onChange={checkPassWord}
              />
              <br/>
              {!passwordMatch && <span className="CampaignSummaryAuth_error-message">Passwords don't match</span>}
            </div>
          )}

          <div className="CampaignSummaryAuth_right-button" onClick={handleClick}>
            {window.location.pathname === '/signup'
              ? `Create account`
              : `Sign in`}
          </div>
        </div>
      </div>
      <CampaignFooter />
    </div>
  );
};

export default CampaignSummaryAuth;
